import { Component, OnInit, Renderer2 } from '@angular/core';
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';

import { ActivatedRoute, Router } from '@angular/router';
import { isPresent } from 'src/providers/common-service';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { MessageDisplayUtil } from 'src/message-display-utils';
import {
  CompetitionCategory,
  CompetitionDetails,
  CompetitionInfo,
  CompetitionTeams,
  createLeaderboardDetails,
  Leaderboard,
  LeaderboardPlayer,
  Teams,
} from 'src/data/competition-data';
import { SearchCriteria } from 'src/data/search-criteria';
import { PlainScorecard } from 'src/data/scorecard';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';
import { AuthenticationService } from 'src/authentication-service';
import { ConnectionService } from 'src/providers/connection-service/connection-service';
import { SessionInfo } from 'src/data/authentication-info';
import { SessionActions, SessionDataService } from 'src/redux/session';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import {
  LeagueLeaderboard,
  LeagueRoundDetails,
  LeagueRound,
  LeaguePlayerTotal,
  LeagueSeason,
  LeagueCompetitionPlayerTotal,
} from 'src/data/mygolf.data';
import { Location } from '@angular/common';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';

import * as global from 'src/globals';

export interface LeaguePlayerTotalExt extends LeaguePlayerTotal {
  showCompetitions?: boolean;
  competitionTotals?: Array<LeagueCompetitionPlayerTotal>;
}

@Component({
  selector: 'app-competition-league-leaderboard',
  templateUrl: './competition-league-leaderboard.page.html',
  styleUrls: ['./competition-league-leaderboard.page.scss'],
})
export class CompetitionLeagueLeaderboardPage implements OnInit {
  searchCriteria: SearchCriteria;
  competition: CompetitionInfo;
  leaderboards: Leaderboard;
  filteredPlayers: Array<LeaguePlayerTotalExt> = new Array<LeaguePlayerTotalExt>();
  //leaderboardPlayers: Array<LeaderboardPlayer> =  new Array<LeaderboardPlayer>();
  leaderboardPlayers: Array<LeaderboardPlayer> = new Array<LeaderboardPlayer>();
  roundNo: number = 1;
  searchQuery: string = '';
  visible: boolean;

  categories: Array<CompetitionCategory> = new Array<CompetitionCategory>();
  selectedCategoryName: string = '';
  scoringFormat: string;
  details: CompetitionDetails;
  selectedOrderBy: number;
  category: Array<CompetitionCategory> = new Array<CompetitionCategory>();
  errorObj: Leaderboard;

  showSortBy: string = 'Gross';
  showCategoryName: string;
  showRoundNo: string = 'Overall';

  selectedSortBy: number = 2;
  selectedCategoryId: string = '';
  selectedRoundNo: number;

  scorecard: PlainScorecard;

  compTeams: CompetitionTeams;

  private needRefresh: boolean = true;

  sortToggle: boolean = true;

  refreshedAttempt: boolean = false;

  hideHomeButton: boolean = false;
  showLogout: boolean = false;
  doneRefresh: boolean = false;
  errorMsg: string = '';
  session: SessionInfo;

  showTeam: boolean = false;
  showEventMode: string = '';
  scorecardView: number = 3;
  leagueLeaderboard: LeagueLeaderboard;
  compSeasonId: number;
  currentSeasonRound: LeagueRound;
  leagueRounds: Array<LeagueRound>;

  leagueType: string = 'Eclectic';

  orderBy: string = 'league';
  public leagueSeason: LeagueSeason;

  constructor(
    private router: Router,
    public nav: NavController,
    private renderer: Renderer2,
    private keyboard: Keyboard,
    private connService: ConnectionService,
    public navParams: NavParams,
    private modalCtl: ModalController,
    private loadingCtl: LoadingController,
    private toastCtl: ToastController,
    private actionSheetCtl: ActionSheetController,
    private auth: AuthenticationService,
    private compService: CompetitionService,
    private platform: Platform,
    private sessionService: SessionDataService,
    private sessionActions: SessionActions,
    private scorecardService: ScorecardService,
    private alertCtrl: AlertController,
    private flightService: ClubFlightService,
    public route: ActivatedRoute,
    private location: Location
  ) {
    if (!this.router.getCurrentNavigation().extras.state) {
      this.onHomeClick();
    }

    this.showCategoryName = 'All Categories';
    this.searchCriteria = compService.getSearch();
    this.hideHomeButton = this.router.getCurrentNavigation().extras.state.hideHomeButton;
    this.showLogout = this.router.getCurrentNavigation().extras.state.showLogout;
    if (this.router.getCurrentNavigation()?.extras?.state.leagueType)
      this.leagueType = this.router.getCurrentNavigation()?.extras?.state.leagueType;
    if (!isPresent(this.searchCriteria.competitionLeaderboardSortBy))
      this.searchCriteria.competitionLeaderboardSortBy = 2;
    this.selectedOrderBy = 2; //this.searchCriteria.competitionLeaderboardSortBy;
    this.selectedSortBy = this.selectedOrderBy;
    if (!isPresent(this.searchCriteria.competitionLeaderboardGroupBy)) {
      this.searchCriteria.competitionLeaderboardGroupBy = '';
    }

    if (this.router.getCurrentNavigation()?.extras?.state) {
      this.leagueSeason = this.router.getCurrentNavigation()?.extras?.state?.leagueSeason;
    }
    this.searchQuery = '';
    this.visible = false;

    if (this.router.getCurrentNavigation().extras.state.leaderboards) {
      this.competition = this.router.getCurrentNavigation().extras.state.competition;
      this.scoringFormat = this.competition.scoringFormat;
      this.leaderboards = this.router.getCurrentNavigation().extras.state.leaderboards;
      this.leaderboardPlayers = this.router.getCurrentNavigation().extras.state.leaderboardPlayers;
      this.filteredPlayers = this.leaderboardPlayers;
      this.roundNo = this.router.getCurrentNavigation().extras.state.roundNo;
      this.selectedRoundNo = this.roundNo;
      this.showRoundNo = 'Round ' + String(this.roundNo);
      this.categories = this.router.getCurrentNavigation().extras.state.categories;

      this.compService.setLeaderboardFilter(this.selectedOrderBy, this.roundNo);
      if (this.competition.teamEvent) {
        // this.showCategoryName = "All Teams";
        // this.compTeams        = navParams.get("teams");
        this.showTeam = this.router.getCurrentNavigation().extras.state.showTeam;
        if (this.showTeam) this.showEventMode = 'View Individual';
        else this.showEventMode = 'View Teams';
      }
      if (this.leagueType === 'Positional') this.refreshOOMpositions(null);
      else this.refreshLeaderboard(null);
    } else {
      this.competition = this.router.getCurrentNavigation().extras.state.competition;
      this.roundNo = this.router.getCurrentNavigation().extras.state.roundNo;
      this.selectedRoundNo = this.roundNo;
      this.showRoundNo = 'Round ' + String(this.roundNo);
      this.scoringFormat = this.competition.scoringFormat;
    }
    this.leaderboards = createLeaderboardDetails();
    this.errorObj = createLeaderboardDetails();
    this.compSeasonId = this.router.getCurrentNavigation().extras.state.compSeasonId;
  }

  ngOnInit() {
    if (this.needRefresh) {
      if (!this.router.getCurrentNavigation().extras.state.leaderboards) {
        if (this.leagueType === 'Positional') this.refreshOOMpositions(null);
        else this._setLeaderboardFilter(); // this.refreshLeaderboard(null);
      } else {
        if (this.leagueType === 'Positional') this.refreshOOMpositions(null);
        else {
          this._setLeaderboardFilter(true);
          this.refreshCompetitionDetails();
        }
      }
    }
  }

  ionViewDidLoad() {
    if (this.needRefresh) {
      if (!this.router.getCurrentNavigation().extras.state.leaderboards)
        if (this.leagueType === 'Positional') this.refreshOOMpositions(null);
        else this._setLeaderboardFilter();
      // this.refreshLeaderboard(null);
      else {
        if (this.leagueType === 'Positional') this.refreshOOMpositions(null);
        else {
          this._setLeaderboardFilter(true);
          this.refreshCompetitionDetails();
        }
      }
    }
    // this.refreshLeagueLeaderboard();
  }

  onBackpage() {
    this.location.back();
  }
  // goHome(){
  //   this.router.navigate(['tabs/player-home'])
  // }

  toggleTeamEvent() {
    if (this.showTeam) {
      this.showTeam = false;
      this.showEventMode = 'View Teams';
    } else if (!this.showTeam) {
      this.showTeam = true;
      this.showEventMode = 'View Individuals';
    }
    this._setLeaderboardFilter();
  }
  async deriveSession() {
    this.session = await this.sessionService.getSession().toPromise();
  }
  toggleSearch() {
    this.visible = !this.visible; //searchBar;//
  }

  onSearchCancel() {
    this.toggleSearch();
    if (this.platform.is('ios') && this.platform.is('capacitor')) this.keyboard.hide();
  }

  async onOptionClick() {
    // let option = await this.modalCtl.create({
    //   component:LeaderboardFiltersPage,
    //   componentProps:{
    //     categories: this.categories,
    //     totalRounds: this.competition.totalRounds,
    //     currentRound: this.roundNo,
    //     compId: this.competition.competitionId,
    //     scoringFormat: this.scoringFormat
    //   }
    // });
    // option.onDidDismiss().then((data: any) => {
    //   if (data.roundNumber >= 0) {
    //     this.roundNo = data.roundNumber;
    //     this.onRefreshClick(null);
    //   }
    //   this.category = data.selectedCategory;//category;
    // });
    // option.present()
  }
  logout() {
    this.sessionActions.logout();
  }
  public onHomeClick() {
    this.router.navigate(['tabs/player-home'], { replaceUrl: false });
  }

  onRefreshClick(refresher) {
    // this.refreshLeaderboard(refresher);
    if (this.leagueType === 'Positional') this.refreshOOMpositions(refresher);
    else this.refreshLeagueLeaderboard(null, refresher);
  }

  onSearchInput(searchbar) {
    if (this.searchQuery && this.searchQuery.length > 0)
      this.filteredPlayers = this.leaderboardPlayers.filter((p: LeaderboardPlayer) => {
        return (
          (p.lastName.toLowerCase() + ' ' + p.firstName.toLowerCase()).indexOf(
            this.searchQuery.toLowerCase()
          ) >= 0
        );
      });
    else this.filteredPlayers = this.leaderboardPlayers;
  }

  private async refreshLeaderboard(refresher) {
    let loader = await this.loadingCtl.create({
      message: 'Refreshing Leaderboard. Please wait...',
    });
    this.leaderboards = createLeaderboardDetails();
    this.errorObj = createLeaderboardDetails();
    this.refreshedAttempt = false;

    loader.present().then(() => {
      this.compService.getLeaderboard(this.competition.competitionId).subscribe(
        (leaderboards: Leaderboard) => {
          loader.dismiss().then(() => {
            this.refreshedAttempt = true;
            this.leaderboards = leaderboards;
            this.leaderboardPlayers = this.leaderboards.players;
            this.filteredPlayers = this.leaderboardPlayers;

            this.doneRefresh = true;
            // new add
            this.refreshLeagueLeaderboard();
          });
        },
        error => {
          loader.dismiss();
          this.doneRefresh = false;
          this.errorObj = error;
          // let msg = "";

          if (refresher) refresher.complete();
          if (!this.connService.isConnected()) {
            this.errorMsg = 'Loading leaderboard failed because your internet connection is down';
          } else
            this.errorMsg = MessageDisplayUtil.getErrorMessage(
              error,
              'Loading leaderboard timed out. Please refresh'
            );

          MessageDisplayUtil.showErrorToast(
            this.errorMsg,
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
        },
        () => {
          if (refresher) refresher.complete();

          if (this.platform.is('ios') && this.platform.is('capacitor')) this.keyboard.hide();
        }
      );
    });
  }

  private async refreshCompetitionDetails() {
    let loader = await this.loadingCtl.create({
      message: 'Please wait...',
    });

    this.refreshedAttempt = false;
    loader.present().then(
      () => {
        this.compService.getDetails(this.competition.competitionId).subscribe(
          (details: any) => {
            this.details = details;
            this.categories = this.details.categories;
            this.compService.getLeaderboard(this.competition.competitionId).subscribe(
              (leaderboards: Leaderboard) => {
                loader.dismiss().then(() => {
                  this.refreshedAttempt = true;
                  this.leaderboards = leaderboards;
                  this.leaderboardPlayers = this.leaderboards.players;
                  this.filteredPlayers = this.leaderboardPlayers;
                });
              },
              error => {
                loader.dismiss();
                this.errorObj = error;
              },
              () => {
                if (this.platform.is('ios') && this.platform.is('capacitor')) this.keyboard.hide();
                // if (this.leaderboards.totalInPage == 0)
              }
            );
          },
          error => {
            loader.dismiss().then(() => {
              MessageDisplayUtil.showErrorToast(
                'Error getting competition details',
                this.platform,
                this.toastCtl,
                3000,
                'bottom'
              );
            });
          },
          () => {}
        );
      },
      error => {}
    );
  }

  private _setLeaderboardFilter(firstRefresh = false) {
    let selectedRoundNo;

    if (this.selectedRoundNo == 0) selectedRoundNo = '';
    else if (this.competition.totalRounds == 1) selectedRoundNo = '';
    else selectedRoundNo = this.selectedRoundNo;
    this.compService.setLeaderboardFilter(
      this.selectedSortBy,
      selectedRoundNo,
      this.selectedCategoryId,
      this.showTeam
      // this.competition.teamEvent
    );
    if (!firstRefresh) {
      this.refreshLeaderboard(null);
    }
    // this.refreshCompetitionDetails();
  }

  public async openCategory() {
    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });
    let tempCategoryName = '';
    if (this.categories.length > 0) tempCategoryName = 'All Categories';
    else tempCategoryName = 'No Category';
    actionSheet.buttons.push({
      text: tempCategoryName,
      role: 'destructive',
      icon: 'filter',
      handler: () => {
        actionSheet.dismiss().then(() => {
          this.selectedCategoryId = '';
          this._setLeaderboardFilter();
          this.showCategoryName = tempCategoryName;
        });
        return false;
      },
    });

    this.categories.forEach((c: CompetitionCategory) => {
      if (c.forGrouping) {
        actionSheet.buttons.push({
          text: c.categoryName + ' (' + c.fromHandicap + ' - ' + c.toHandicap + ')',
          role: 'destructive',
          icon: 'filter',
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.showCategoryName =
                c.categoryName + ' (' + c.fromHandicap + ' - ' + c.toHandicap + ')';
              this.selectedCategoryId = String(c.categoryId);
              this._setLeaderboardFilter();
            });
            return false;
          },
        });
      }
    });
    actionSheet.present();
  }

  public async openSortBy() {
    // this.showSortBy = "";
    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Gross',
          role: 'destructive',
          icon: !this.platform.is('ios') ? 'exit' : null,
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.toggleSortBy('gross');
            });
            return false;
          },
        },
        {
          text: 'Net',
          icon: !this.platform.is('ios') ? 'cog' : null,
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.toggleSortBy('net');
            });

            return false;
          },
        },
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });

    actionSheet.present();
  }

  public async openRound() {
    // this.showRoundNo = "";
    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });
    let roundNo = this.competition.totalRounds;

    actionSheet.buttons.push({
      text: 'Overall',
      role: 'destructive',
      icon: !this.platform.is('ios') ? 'exit' : null,
      handler: () => {
        actionSheet.dismiss().then(() => {
          this.showRoundNo = 'Overall';
          this.selectedRoundNo = 0;
          this.roundNo = 0;
          this._setLeaderboardFilter();
        });
        return false;
      },
    });
    for (let i = 1; i <= roundNo; i++) {
      actionSheet.buttons.push({
        text: 'Round ' + i,
        role: 'destructive',
        icon: 'filter',
        handler: () => {
          actionSheet.dismiss().then(() => {
            this.showRoundNo = 'Round ' + i;
            this.selectedRoundNo = i;
            this.roundNo = i;
            this._setLeaderboardFilter();
          });
          return false;

          //  this.goScorecard();
        },
      });
    }

    actionSheet.present();
  }

  getSortBy(sortBy: string) {
    // defining class

    if (sortBy == 'gross' && this.searchCriteria.competitionLeaderboardSortBy == 2)
      return 'sortedBy';
    if (
      sortBy == 'net' &&
      (this.searchCriteria.competitionLeaderboardSortBy == 3 ||
        this.searchCriteria.competitionLeaderboardSortBy == 4)
    )
      return 'sortedBy';
  }

  toggleSortBy(sortBy: string) {
    if (this.showSortBy.toLowerCase() == sortBy) return false;

    if (sortBy == 'gross') {
      this.showSortBy = 'Gross';
      this.selectedSortBy = 2;
      this._setLeaderboardFilter();
      this.sortToggle = true;
    } else if (sortBy == 'net') {
      if (this.scoringFormat != 'Stableford' && this.scoringFormat != 'Peoria')
        this.selectedSortBy = 3;
      if (this.scoringFormat == 'Stableford' || this.scoringFormat == 'Peoria')
        this.selectedSortBy = 4;
      this.showSortBy = 'Net';
      this.sortToggle = false;

      this._setLeaderboardFilter();
    }
  }

  // async getPlayerScorecard(playerId: string) {
  //   let loader = await this.loadingCtl.create({
  //     // dismissOnPageChange: true,
  //     showBackdrop: false,
  //     cssClass: "nobg"
  //   });
  //   loader.present().then(() => {
  //     this.scorecardService.getCompetitionScorecard(this.competition.competitionId, this.selectedRoundNo, Number(playerId), true)
  //       .subscribe((scorecard: PlainScorecard) => {
  //         loader.dismiss().then(() => {
  //           let subTitle = "No scorecard to display";
  //           if (scorecard) {
  //             this.nav.push(ScorecardDisplayPage, {
  //               scorecard: scorecard,
  //               editing: true
  //             });
  //           } else MessageDisplayUtil.displayInfoAlert(this.alertCtrl, "", subTitle, "OK");

  //         });
  //       }, (error) => {
  //         loader.dismiss().then(() => {
  //           let subTitle = "No scorecard to display";
  //           MessageDisplayUtil.displayInfoAlert(this.alertCtrl, "", subTitle, "OK");
  //         });

  //       }, () => {

  //       });
  //   });

  // }

  public async openTeams() {
    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });
    let tempTeamName = '';
    if (this.compTeams.totalItems > 0) tempTeamName = 'All Teams';
    else tempTeamName = 'No Team';
    actionSheet.buttons.push({
      text: tempTeamName,
      role: 'destructive',
      icon: 'filter',
      handler: () => {
        actionSheet.dismiss().then(() => {
          this.selectedCategoryId = '';
          this._setLeaderboardFilter();
          return false;
        });

        //  this.goScorecard();
      },
    });

    this.compTeams.competitionTeams.forEach((c: Teams) => {
      // if (c.forGrouping) {
      actionSheet.buttons.push({
        text: c.teamName,
        role: 'destructive',
        icon: 'filter',
        handler: () => {
          actionSheet.dismiss().then(() => {
            this.showCategoryName = c.teamName;
            this.selectedCategoryId = String(c.teamId);
            this._setLeaderboardFilter();

            return false;
          });

          //  this.goScorecard();
        },
      });
      // }
    });
    actionSheet.present();
  }

  checkScoringCategory() {
    let hasScoringCategory: boolean = false;
    this.categories.forEach((c: CompetitionCategory) => {
      if (c.forGrouping) {
        hasScoringCategory = true;
        // return c.forGrouping
      }
    });
    return hasScoringCategory;
  }

  changeScorecardView(view: number) {
    this.scorecardView = view;
  }

  refreshLeagueLeaderboard(compId?: number, refresher?) {
    let _compId;
    if (compId) _compId = compId;
    else _compId = this.competition.competitionId;
    this.flightService.getLeagueLeaderboard(_compId, this.compSeasonId).subscribe(
      (data: LeagueLeaderboard) => {
        if (data) {
          this.leagueLeaderboard = data;
          this.getLeagueRounds(this.compSeasonId);
          this.currentSeasonRound = data.leagueRound;
        }
        if (refresher) refresher.complete();
      },
      error => {
        if (refresher) refresher.complete();
      }
    );
  }

  getLeagueRounds(seasonId: number) {
    this.flightService.getLeagueRounds(seasonId).subscribe(data => {
      this.leagueRounds = data;
    });
  }

  prevRound() {
    let _idx;
    this.leagueRounds.forEach((lr, idx) => {
      if (lr.competitionId === this.currentSeasonRound.competitionId) {
        if (lr.roundNo === this.currentSeasonRound.roundNo) {
          _idx = idx;
        }
      }
    });
    if (_idx >= 0) {
      this.refreshLeagueLeaderboard(this.leagueRounds[_idx - 1].competitionId);
      // this.currentSeasonRound = this.leagueRounds[_idx-1];
    }
  }

  nextRound() {
    let _idx;
    this.leagueRounds.forEach((lr, idx) => {
      if (lr.competitionId === this.currentSeasonRound.competitionId) {
        if (lr.roundNo === this.currentSeasonRound.roundNo) {
          _idx = idx;
        }
      }
    });
    if (_idx >= 0) {
      this.refreshLeagueLeaderboard(this.leagueRounds[_idx + 1].competitionId);
      // this.currentSeasonRound = this.leagueRounds[_idx-1];
    }
  }

  getTitle() {
    return 'Eclectic Leaderboard';
  }

  changeRound(roundNo?: number) {
    console.debug('change round : ', this.currentSeasonRound.roundNo, roundNo);
    console.debug('change round : ', this.currentSeasonRound, this.leagueRounds);
    let _idx;
    let _compId: number;
    _compId = this.leagueRounds
      .filter((lr, idx) => {
        if (lr.roundNo === roundNo) return true;
        else return false;
      })
      .map(lr => {
        return lr.competitionId;
      })[0];
    console.debug('change round : ', _compId);
    // if (_idx >= 0) {
    if (_compId) this.refreshLeagueLeaderboard(_compId);
    // this.currentSeasonRound = this.leagueRounds[_idx-1];
    // }
  }

  getCompImage(competition) {
    if (!competition) {
      if (this.competition.thumbnail) return this.competition.thumbnail;
      else return this.competition.imageUrl;
    } else {
      return competition.thumbnail || competition.imageUrl;
    }
  }

  getLeaguePlayerImage(player) {
    if (!player) return 'assets/image/default_user.png';
    // if(player?.player?.image) console.debug("get player image : ", player);
    let _playerImage = '';
    if (player?.player?.profile) _playerImage = player.player.profile;
    else if (player?.player?.image) _playerImage = player.player.image;
    else return 'assets/image/default_user.png';

    if (_playerImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _playerImage;
    else return global.MygolfServer + '/' + _playerImage;
  }

  getEclecticPlayerImage(player) {
    if (!player) return 'assets/image/default_user.png';
    // if(player?.player?.image) console.debug("get player image : ", player);
    let _playerImage = '';
    if (player?.photo) _playerImage = player?.photo;
    else if (player?.photo === '') return 'assets/image/default_user.png';
    else return 'assets/image/default_user.png';

    if (_playerImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _playerImage;
    else return global.MygolfServer + '/' + _playerImage;
  }

  getSeasonImage() {
    // console.debug("get season image : ", this.leagueSeason)
    let _leagueImage = this.leagueSeason?.league?.leagueImage;
    if (_leagueImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _leagueImage;
    else return global.MygolfServer + '/' + _leagueImage;
  }

  oomLeaderboard: Array<LeaguePlayerTotal> = [];
  refreshOOMpositions(refresher) {
    let _orderBy: string = 'league';
    let _qualifiedOnly: boolean = this.qualifiedOnly;
    this.oomLeaderboard = [];
    this.filteredPlayers = [];
    if (this.orderBy) _orderBy = this.orderBy;

    this.flightService.getOOMposition(this.compSeasonId, _orderBy, _qualifiedOnly).subscribe(
      (data: Array<LeaguePlayerTotal>) => {
        if (data) {
          if (this.orderBy === 'points') {
            data.sort((a, b) => {
              if (a.stablefordPointsPosition < 0) return 1;
              else return a.stablefordPointsPosition - b.stablefordPointsPosition;
            });
          }
          this.oomLeaderboard = data;
          this.filteredPlayers = data;
        }
        if (refresher) refresher.complete();
      },
      error => {
        if (refresher) refresher.complete();
      }
    );
  }

  getOOMposition(player: LeaguePlayerTotal, attribute: string) {
    if (!player) return;
    switch (attribute) {
      case 'playerName':
        return player?.player?.playerName;
      case 'position':
        if (this.orderBy === 'league') return player?.leaguePosition;
        else if (this.orderBy === 'gross') return player?.grossPosition;
        else if (this.orderBy === 'net') return player?.netPosition;
        else if (this.orderBy === 'points') return player?.stablefordPointsPosition;
        else if (this.orderBy === 'positional') return player?.positionalPosition;
      case 'leagueTotals':
        if (this.orderBy === 'league') return player?.totalPositionalPoints;
        else if (this.orderBy === 'gross') return player?.totalGross;
        else if (this.orderBy === 'net') return player?.totalNet;
        else if (this.orderBy === 'points') return player?.totalStablefordPoints;
        else if (this.orderBy === 'positional') return player?.totalPositionalPoints;
      case 'participations':
        return player?.leagueTotals?.totalParticipation;
      case 'totalParticipations':
        return player?.totalParticipationPoints;
      // if(this.orderBy === 'league') return player?.totalPositionalPoints;
      // else if(this.orderBy === 'gross') return player?.leagueTotals?.totalGross;
      // else if(this.orderBy === 'net') return player?.leagueTotals?.totalNet;
      // else if(this.orderBy === 'points') return player?.totalStablefordPoints;
      // else if(this.orderBy === 'positional') return player?.totalPositionalPoints;
      case 'participationPoints':
        if (this.orderBy === 'league') return player?.totalPositionalPoints;
        else if (this.orderBy === 'gross') return player?.leagueTotals?.totalGross;
        else if (this.orderBy === 'net') return player?.leagueTotals?.totalNet;
        else if (this.orderBy === 'points') return player?.totalStablefordPoints;
        else if (this.orderBy === 'positional') return player?.totalPositionalPoints;
    }
  }

  async onChangeOrderBy() {
    let _dataList = [];

    _dataList.push({
      id: 'league',
      name: 'League',
    });
    _dataList.push({
      id: 'gross',
      name: 'Gross',
    });
    _dataList.push({
      id: 'net',
      name: 'Net',
    });
    _dataList.push({
      id: 'points',
      name: 'Points',
    });
    _dataList.push({
      id: 'positional',
      name: 'Positional',
    });

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        headerTitle: 'Order By',
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data?.data) {
        this.orderBy = data?.data?.id;
        this.refreshOOMpositions(null);
      }
    });
  }

  qualifiedOnly: boolean = false;
  onQualifiedOnlyChange(event) {
    this.refreshOOMpositions(null);
  }

  showPlayerCompetitionsTotal(player: LeaguePlayerTotalExt) {
    if (!player) return;
    // if(1) { // use new scorecards API
    //   this.getScorecardsByPlayer(player);
    //   // return;
    // }
    player.showCompetitions = !player.showCompetitions;
    if (!player.showCompetitions) return;
    let _playerId = player?.player?.id || player?.player?.playerId;
    this.flightService
      .getLeagueCompPlayerTotals(this.leagueSeason.id, _playerId)
      .subscribe((data: Array<LeagueCompetitionPlayerTotal>) => {
        if (data) {
          // let _filteredRoundScores = data.filter((scores: LeagueCompetitionPlayerTotal) => {
          //   return scores && scores.roundNo === this.roundNo;
          // }).map(scores => scores);
          data.sort((a, b) => {
            if (a?.competition?.startDate < b?.competition?.startDate) return 1;
            else if (a?.competition?.startDate > b?.competition?.startDate) return -1;
            else return 0;
          });

          let _getIndex = this.filteredPlayers.findIndex((fp: LeaguePlayerTotalExt) => {
            return fp?.player?.id === _playerId;
          });
          this.filteredPlayers[_getIndex].competitionTotals = [];
          this.filteredPlayers[_getIndex].competitionTotals.push(...data);
        }
        // filter by round as well
      });
  }
}
